export default __webpack_public_path__ + "static/media/105-birds-chirping.aca331ec.jpeg";